import PropTypes from "prop-types";
import { forwardRef } from "react";
// icons
import { Icon } from "@iconify/react";
// ----------------------------------------------------------------------

const Iconify = forwardRef(({ icon, width = 20, style, ...other }, ref) => (
    <Icon
        ref={ref}
        icon={icon}
        style={{ width, height: width, ...style }}
        {...other}
    />
));

Iconify.propTypes = {
    style: PropTypes.object,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default Iconify;
